const C = { roy: '#85BB65', royDark: '#5E9444', bg: '#F0F2F0', surface: '#FAFBFA', border: '#E8EBE8', text: '#1A1E1A', text2: '#4A5248', text3: '#8A948A' };

function Section({ title, children }) {
  return (
    <div style={{ marginBottom: 40 }}>
      <h2 style={{ fontFamily: "'Raleway', sans-serif", fontWeight: 800, fontSize: 20, color: C.text, marginBottom: 12, marginTop: 0 }}>{title}</h2>
      <div style={{ fontFamily: "'Open Sans', sans-serif", fontSize: 14, color: C.text2, lineHeight: 1.85 }}>{children}</div>
    </div>
  );
}

export default function Terms() {
  return (
    <div style={{ paddingTop: 64, background: C.surface, minHeight: '100vh' }}>
      <div style={{ maxWidth: 760, margin: '0 auto', padding: '60px 24px 96px' }}>
        <p style={{ fontFamily: "'Raleway', sans-serif", fontWeight: 700, fontSize: 11, color: C.roy, letterSpacing: '0.14em', textTransform: 'uppercase', marginBottom: 12 }}>Legal</p>
        <h1 style={{ fontFamily: "'Raleway', sans-serif", fontWeight: 900, fontSize: 'clamp(32px, 5vw, 52px)', color: C.text, marginBottom: 12, marginTop: 0, letterSpacing: '-0.025em' }}>Terms of Service</h1>
        <p style={{ fontFamily: "'Open Sans', sans-serif", fontSize: 13, color: C.text3, marginBottom: 48 }}>Last updated: January 2026</p>

        <Section title="1. About Korunto">
          Korunto is a loyalty platform that allows customers to earn and spend points across participating vendor businesses in the United Kingdom. By using Korunto, you agree to these terms.
        </Section>

        <Section title="2. Customer accounts">
          <p style={{ marginTop: 0 }}>To earn and spend points, you must create a free Korunto account. You agree to:</p>
          <ul style={{ paddingLeft: 20, marginTop: 8 }}>
            <li>Provide accurate information when registering</li>
            <li>Keep your login credentials secure</li>
            <li>Not share your account with others</li>
            <li>Not attempt to manipulate or abuse the points system</li>
          </ul>
        </Section>

        <Section title="3. Loyalty points">
          <p style={{ marginTop: 0 }}>Points are awarded by vendors at their discretion. Korunto does not guarantee any minimum level of point awards. Points:</p>
          <ul style={{ paddingLeft: 20, marginTop: 8 }}>
            <li>Are securely and independently held — protected even if Korunto ceases to operate</li>
            <li>Expire after 365 days of account inactivity — any transaction resets this window</li>
            <li>Have no cash value and cannot be exchanged for money</li>
            <li>Can be converted to Korunto Credits and spent at any participating store</li>
          </ul>
        </Section>

        <Section title="4. Vendor accounts">
          <p style={{ marginTop: 0 }}>Businesses that join Korunto as vendors agree to:</p>
          <ul style={{ paddingLeft: 20, marginTop: 8 }}>
            <li>Honour point awards and redemptions made through the platform</li>
            <li>Provide accurate business information</li>
            <li>Pay the applicable monthly subscription fee after the 30-day free trial</li>
            <li>Not issue points fraudulently or in breach of the platform's fair-use limits</li>
          </ul>
          <p>Korunto reserves the right to suspend or remove vendors who breach these terms.</p>
        </Section>

        <Section title="5. Subscriptions and payments">
          Vendor subscriptions are billed monthly, starting at £49/month after the free trial. You may cancel at any time. No refunds are issued for partial months. Korunto reserves the right to change subscription prices with 30 days' notice.
        </Section>

        <Section title="6. Vendor wind-down">
          If a vendor leaves the platform, customers will be given a grace period (minimum 30 days) to redeem or convert their points before those points expire. Korunto will notify affected customers by email.
        </Section>

        <Section title="7. Prohibited use">
          <p style={{ marginTop: 0 }}>You must not use Korunto to:</p>
          <ul style={{ paddingLeft: 20, marginTop: 8 }}>
            <li>Commit fraud or abuse the loyalty system</li>
            <li>Create multiple accounts to gain unfair advantages</li>
            <li>Attempt to access accounts that are not yours</li>
            <li>Reverse-engineer or interfere with the platform</li>
          </ul>
        </Section>

        <Section title="8. Limitation of liability">
          Korunto is provided "as is." We are not liable for any loss of points caused by infrastructure issues, vendor closures, or circumstances outside our reasonable control. Our maximum liability to any user is limited to the subscription fees paid in the preceding 3 months.
        </Section>

        <Section title="9. Changes to these terms">
          We may update these terms at any time. We will notify you by email of material changes. Continued use of Korunto after the effective date of changes constitutes acceptance.
        </Section>

        <Section title="10. Governing law">
          These terms are governed by the laws of England and Wales. Any disputes shall be subject to the exclusive jurisdiction of the courts of England and Wales.
        </Section>

        <Section title="11. Contact">
          For any questions about these terms, contact us at <a href="mailto:hello@korunto.com" style={{ color: C.royDark }}>hello@korunto.com</a>.
        </Section>
      </div>
    </div>
  );
}
